<template>
    <!-- <div class="user-info" v-global-click-event="hideInfo"> -->
            <div class="header-wrap scroll-fixed-bg" v-global-click-event="hideInfo">
                <div token="?token=d0cc5eb7db2c948b2592a117cb9081dcac4feefa" class="user-info">
                    <div class="ellipsis" v-if="!account.previewFlag" @click="showMoreFunc(4)">Hi, {{ account.acccode }}</div>
                    <div class="ellipsis" v-else @click="showPanel">Hi, Guest</div>
                </div>
                <div class="balance-wrap vrow justify-between relative-position">
                    <div class="vrow items-center">
                        <div class="balance-text-hide" v-if="!showCCL">******</div>
                        <div class="balance-text-show" v-else>{{ account.currCode }}<sup>{{ account.currUnit_S }}</sup> {{ account.currCL | ccl(decimals) }}</div>
                        <i  aria-hidden="true" role="presentation"
                            class="balance-btn-eye cursor-pointer q-icon c-icon"
                            :class="showCCL ? 'icon-eye_show' : 'icon-eye_hide'" style="font-size: 14px;"
                            @click="CCL"></i>
                    </div>
                    <!-- <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn" @click="getSportCCL(0)" v-if="showCCL">
                        <div class="icon-wrap" id="balancesRefresh">
                            <span class="icon-balance_refresh">
                                <span class="path1"></span>
                                <span class="path2" style="left:0px; position:absolute"></span>
                                <span class="path3" style="left:0px; position:absolute"></span>
                            </span>
                        </div>
                    </div> -->
                    <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn" @click="getSportCCL(0)" v-if="showCCL">
                        <div id="balancesRefresh" class="icon-wrap">
                            <i aria-hidden="true" role="presentation" class="q-icon icon-tbl_refresh c-icon" style="font-size: 18px; transform: scale(0.8);"></i>
                        </div>
                    </div>
                </div>

                <div tabindex="-1" class="widgetPanel personalAccount" @click="showPanelMini" style="display:none">
                    <button class="glyphIcon icon-widgetCollapse" title="Collapse the Widget Panel"
                        @click="hideInfo"></button>
                    <div class="heading current" :title="account.acccode">
                        <!-- <div class="heading icon-account current" :title="account.acccode"> -->
                        <div class="text" v-if="!account.previewFlag" @click="showPanel">{{ account.acccode }}</div>
                        <div class="text" v-else @click="showPanel">Guest</div>
                        <div class="floatRight">
                            <div class="glyphIcon primary icon-refresh" :title="langList.refresh" @click="getSportCCL(0)"
                                v-if="checked"></div>
                            <div class="glyphIcon icon-widgetCollapse" data-tag="tagGlyphIconButton" v-if="!isMini">
                            </div>
                        </div>
                    </div>


                    <div class="creditArea" v-if="checked">
                        <div class="infoGroup creditInfo">
                            <div class="infoRow">
                                <div class="infoTitle" :title="langList.balances">{{ langList.balances }}</div>
                                <div class="infoItem"><span class="currency">{{ account.currCode }}<sup>{{
                                    account.currUnit_S
                                }}</sup> </span>{{ account.currCL | ccl(decimals) }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="creditArea" v-if="checked">
                        <div class="infoGroup creditInfo">
                            <div class="infoRow">
                                <div class="infoTitle" :title="langList.balances">{{ langList.balances }}</div>
                                <div class="infoItem"><span class="currency">{{ account.currCode }}<sup>{{
                                    account.currUnit_S
                                }}</sup> </span>{{ account.currCL | ccl(decimals) }}</div>
                            </div>
                        </div>
                    </div> -->
                    <div id="AccountList" class="contentArea" style="display:none;">
                        <div class="mainSection">
                            <div class="panelFunction">
                                <div class="floatLeft">
                                    <label :title="langList.showBetCredit" class="sb_label">
                                        <input id="" type="checkbox" checked="" @click="getChecked">
                                        <div class="checkbox"></div> {{ langList.showBalance }}
                                    </label>
                                </div>
                                <div class="floatRight">
                                    <!-- <div class="glyphIcon iconOnly icon-preferences"></div> -->
                                    <div class="largeBtn iconOnly secondary icon-refresh" title=""></div>
                                </div>
                            </div>
                            <div class="detailAccount">
                                <div class="infoGroup creditInfo">
                                    <div class="infoRow">
                                        <div class="infoTitle" :title="langList.balances">{{ langList.balances }}</div>
                                        <div class="infoItem"><span class="currency">{{ account.currCode }}<sup>{{
                                            account.currUnit_S
                                        }}</sup> </span>{{ account.currCL | ccl(decimals) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="infoGroup creditInfo">
                                    <div class="infoRow">
                                        <div class="infoTitle" :title="langList.balances">{{ langList.outstanding }}
                                        </div>
                                        <div class="infoItem">{{ account.outstanding | decimal(decimals) }}</div>
                                    </div>
                                </div>
                                <div class="infoGroup loginInfo">
                                    <div class="infoRow">
                                        <div class="infoTitle" :title="langList.lastLogin">{{ langList.lastLogin }}
                                        </div>
                                        <div class="infoItem">{{ account.lastLogin | date('DD/MM/Y hh:mm:ss A') }}
                                        </div>
                                    </div>
                                    <div class="infoRow" v-if="account.oneWallet !== '1'">
                                        <div class="infoTitle" :title="langList.LasTransaction">{{
                                            langList.LasTransaction
                                        }}
                                        </div>
                                        <div class="infoItem" v-if="account.lastTrans != ''">{{
                                            account.lastTrans | date('DD/MM/Y hh: mm: ss A')
                                        }}</div>
                                        <div class="infoItem" v-else>-</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        
        <!--BODY-->
        <!-- <allSport></allSport> -->
</template>

<script>

import {
    mapGetters
} from 'vuex'

import EventBus from '../../../events/event-bus'
import sportMatchCount from '@/vue/mixins/sportMatchCount'
// import sportCategory from './sportCategory'
import allSport from './allSport'

import VueFilterNumber from '@/vue/filters/vue-filter-number'

export default {
    components: {
        // sportCategory, 
        allSport
    },
    computed: {
        ...mapGetters([
            'account',
            'langList',
            'checked',
            'betLang',
            'allSportCount',
            'sportList',
            'selectedMarket',
            // 'oddSelected',
            // 'selectedTab'
        ]),
        decimals: function () {
            return this.account._showDecimals ? 2 : 0
        },
        bettypeList() {
            var availableBettypeList = this.$store.getters.bettypeList
            //var filter
            if(this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key){
                availableBettypeList = _.remove(availableBettypeList, function(bettype) {
                    return bettype.betTypId != '5' || bettype.betTypId != '6'
                })
            }
            return availableBettypeList
        },
    },
    data() {
        return {
            sportBettypeList: window.sportBettypeList,
            // checked: true,
            isMini: false,
            showCCL: true,
            timerSeconds: 60,
            timerSec: 60,
        }
    },
    methods: {
        CCL(){
            if(this.showCCL == true){
                this.showCCL = false;
            }else{
                this.showCCL = true;
            }
        },
        showMoreFunc(msg) {
            if (!this.account.previewFlag) {
                let height = window.screen.availHeight - 50;
                let width = window.screen.availWidth - 100;
                if (width > 1024) {
                    width = 1024;
                }

                if(height>600){
                    height=600
                }
                
                if (msg == 0) {
                    window.open('sport-wager?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ''); //wgrTyp=openBet&page=1&sprtId=99
                } else if (msg == 1) {
                    window.open('statement?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                    // window.open('statement/summary/99/0/7/1', 'MsgWindow',  'width='+width+', height='+height+'');
                } else if (msg == 2) {
                    window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                } else if (msg == 5){
                    window.open('sport-information?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '')
                } else if (msg == 4) {
                    window.open('account-settings?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '')
                } 
            }
        },
        changeMarket(market) {
            EventBus.$emit('viewAccountSetting', false)
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            switch (market) {
                case this.$store.getters.market.inPlayMarket.key:
                    this.$store.commit('SPORTFORECAST_LIST', null)
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.inPlayMarket.key)
                    this.resetSportBettype()
                    EventBus.$emit('refreshOdd', true);
                    EventBus.$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
                    break;
                case this.$store.getters.market.tdyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key)
                    this.resetSportBettype()
                    EventBus.$emit('refreshOdd', true);
                    EventBus.$emit('marketChange', this.$store.getters.market.tdyMarket.key);
                    break;
                case this.$store.getters.market.earlyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key)
                    this.resetSportBettype()
                    EventBus.$emit('refreshOdd', true);
                    EventBus.$emit('marketChange', this.$store.getters.market.earlyMarket.key);
                    break;
                default:
                    return false;
            }
            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            })
        },
        title_display(selectedMarket){
            if(selectedMarket==1){
                return this.langList.welcomeTdyMarket;
            }else if(selectedMarket==3){
                return this.langList.welcomeInPlay;
            }else{
                return this.langList.welcomeEarlyMarket;
            }
        },
        getSportCCL(loadAction) {
            if (!this.account.previewFlag) {
                $('#balancesRefresh').addClass('loading-static-animation')
                var active = $('.widgetPanel.personalAccount').hasClass('active')
                if (loadAction == 0 || (loadAction == 1 && active)) {
                    if (active) {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                            showB: true,
                        })
                    } else {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                        })
                    }
                }
            }
        },
        startTimer() {
            if(this.timerIdccl == null){
                this.timerIdccl = setInterval(() => {
                    if(this.timerSeconds - 1 < 0) {
                        this.$store.dispatch('getSportCCL',{
                            token: token.arr_7
                        })
                        this.timerSeconds = this.timerSec
                    } else {
                        this.timerSeconds -= 1;
                    }
                },1000);
            }
        },
        clearTimer() {
            clearInterval(this.timerIdccl)
            this.timerIdccl = null
        },
        getChecked() {
            if (this.checked) {
                this.$store.commit('CHECKED_BALANCE', false)
            } else {
                this.$store.commit('CHECKED_BALANCE', true)
            }
        },
        hideInfo() {
            var active = $('.widgetPanel.personalAccount').hasClass('active')
            if (active) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
            }
            $('.widgetPanel.personalAccount').removeClass('openContent')
            $('.widgetPanel.personalAccount').removeClass('active')
            $('#AccountList').css('display', 'none')
        },
        showPanelMini() {
            if ($('.sidebar-first').hasClass('mini')) {
                this.showPanel();
            }
        },
        countMatch(sprtId, market) {
            
            var Vue = this
            var count = []

            var tdyElyOTR = this.countOTR()
            if(market == '1'){ //today
                $.each(Vue.allSportCount['today'], function(sport, bettype){
                    if(sprtId == 'N1' && sport == 'Soccer'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'G1' && sport == 'Basketball'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N3' && sport == 'Tennis'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N21' && sport == 'Volleyball'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N12' && sport == 'Badminton'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N15' && sport == 'Snooker'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'G2' && sport == 'Others'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }
                })
            }else if(market == '2'){ //early
                $.each(Vue.allSportCount['early'], function(sport, bettype){
                    if(sprtId == 'N1' && sport == 'Soccer'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'G1' && sport == 'Basketball'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N3' && sport == 'Tennis'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N21' && sport == 'Volleyball'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N12' && sport == 'Badminton'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'N15' && sport == 'Snooker'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }else if(sprtId == 'G2' && sport == 'Others'){
                        $.each(bettype, function(key, val){
                            if(key == 'AH'){
                                count.push(val)
                            }else if(key == 'OTR'){
                                count = _.clone(tdyElyOTR)
                            }
                        })
                    }
                })
            }else if(market == '3'){ //live
                $.each(Vue.allSportCount['live'], function(sport, bettype){
                    if(sprtId == 'N1' && sport == 'Soccer'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'G1' && sport == 'Basketball'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'N3' && sport == 'Tennis'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'N21' && sport == 'Volleyball'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'N12' && sport == 'Badminton'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'N15' && sport == 'Snooker'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }else if(sprtId == 'G2' && sport == 'Others'){
                        $.each(bettype, function(key, val){
                            if(key == 'RAH'){
                                count.push(val)
                            }
                        })
                    }
                })
            }

            return _.sum(count)
        },
        countOTR() {
            
            var Vue = this
            var count = [];
            var sportList = Vue.allSportCount

            $.each(sportList['today'], function(sport, bettype){
                $.each(bettype, function(key, val){
                    if(key == 'OTR'){
                        count.push(val)
                    }
                })
            })

            $.each(sportList['early'], function(esport, ebettype){
                $.each(ebettype, function(ekey, eVal){
                    if(ekey == 'OTR'){
                        count.push(eVal)
                    }
                })
            })
            
            return count
        },
        showPanel() {
            if ($('.sidebar-first').hasClass('mini')) {
                this.isMini = true
            }
            var active = $('.widgetPanel.personalAccount').hasClass('active')
            if (active) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
                $('.widgetPanel.personalAccount').removeClass('openContent')
                $('.widgetPanel.personalAccount').removeClass('active')
                // $('.icon-widgetCollapse').css('display','none')
                $('#AccountList').css('display', 'none')
            } else {

                $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
                $('.widgetArea').find('.expendScore').css('width', '40em');
                //    $('.widgetArea').find('.mainSection').find('.scroll-content').css('width', '');
                $('.icon-refresh').addClass('spin')
                $('.widgetPanel.personalAccount').addClass('openContent')
                $('.widgetPanel.personalAccount').addClass('active')
                // $('.icon-widgetCollapse').css('display','block')
                $('#AccountList').css('display', 'block')
                this.getSportCCL(1);
                setInterval(function () {
                    $('.icon-refresh').removeClass('spin')
                }, 1500)
            }
        }
    },
    beforeMount() {
        if (!this.account.previewFlag) {
            this.startTimer()
        }
        this.$store.dispatch('getSportCCL', {
            token: token.arr_7,
        })
        this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList,'sprtId'))
    },
    destroyed(){
        this.clearTimer()
    },
    updated() {
    },
    mounted() {

    },
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/userInfo.vue